// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer-module--wrapper--37bk4","footer":"Footer-module--footer--1Zfza"};